<template>
  <vx-card
    :title="teacherName" body-class="p-0"
    class="mb-base" title-color="primary"
  >
    <template slot="actions">
      <div class="flex justify-end">
        <vs-button radius color="success" type="border" icon="keyboard_backspace"
                   @click="goBack">
        </vs-button>
      </div>
    </template>

    <vs-avatar
      :src="teacherProfile" class="mx-auto block"
      size="90px"/>

    <vs-divider/>
    <div class="flex flex-col justify-start">

        <span v-if="teacher.telephone" class="flex items-center">
          <vs-avatar color="primary" icon="smartphone" />
          <span class="ml-2"> {{ teacher.telephone }} </span>
        </span>

      <span v-if="teacher.email" class="flex items-center">
          <vs-avatar color="success" icon="email" />
          <span class="ml-2"> {{ teacher.email }} </span>
        </span>

      <span v-if="teacher.socialMedia" class="flex items-center">
          <vs-avatar color="danger" icon="link"></vs-avatar>
          <span class="ml-2"> {{ teacher.socialMedia }} </span>
        </span>

      <span v-if="teacher.availableTime" class="flex items-center">
            <vs-avatar color="warning" icon="alarm"> </vs-avatar>
          <span class="ml-2"> {{ teacher.availableTime }} </span>
        </span>

    </div>
  </vx-card>
</template>

<script>
import {getAvatarUrl} from "@/utils/upload";

export default {
  name: "TeacherProfileMini",
  props: ['teacher'],
  computed: {
    teacherProfile() {
      return getAvatarUrl(this.teacher ? this.teacher.picturePath : '');
    },
    teacherName(){
      if(this.teacher){
        let prefix = this.teacher.prefix ? this.teacher.prefix.nameLocal+' ':'';
        return prefix + this.teacher.firstNameLocal + ' ' + this.teacher.lastNameLocal
      }
      return '';
    }
  },
  methods:{
    goBack(){
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>

</style>
